export const mainId = "main";
